import { getRedeemvaluelist, getRsymbollist } from "@/api";
import { echartslineColor, formatNumber } from "@/tool/utils";
import { useEffect, useState } from "react";
import CardHead from "../cardHead";
import Echarts from "../echarts/redeemValueEcharts";
import LoadingOutlined from "../loadingOutlined";
import PricePanel from "../pricePanel";
import "./index.scss";

const types = ["USD", "ETH", "FIS"];

export default function Index() {
  const [typevlue, setTypeValue] = useState<string>("USD");

  const [dropDownValue, setDropDownValue] = useState<string>("Overall");
  const [dropDownDatas, setDropDownDatas] = useState<any[]>([]);

  const [updateTime, setUpdateTime] = useState<any>();
  const [yData, setYData] = useState<any>();
  const [echartList, setEchartList] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [hindPrice, setHindPrice] = useState<boolean>(false);
  const [allReddemValue, setAllReddemValue] = useState<number>();

  useEffect(() => {
    getRsymbollist().then((rsymbollist) => {
      if (rsymbollist.data.status == "80000") {
        setDropDownDatas([
          { label: "Overall", value: "Overall" },
          ...rsymbollist.data.data.map((item: any) => {
            return {
              label: item.chainName,
              value: item.rsymbol,
            };
          }),
        ]);
      }
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    getRedeemvaluelist(
      1,
      dropDownValue == "Overall" ? undefined : dropDownValue,
      1095
    )
      .then((res) => {
        if (res.data.status == "80000") {
          const data = res.data.data;
          setUpdateTime(data.info.updateTime);
          setAllReddemValue(data.info.allReddemValue);
          if (data.list[0].reddemValue) {
            setYData(data.list[0].reddemValue.yData);
          } else {
            setYData(data.list[0].reddemAmount.yData);
          }

          const list: any[] = [];
          if (data.list[0].nativePrice) {
            setHindPrice(false);
            list.push({
              name: `USD Price (${data.list[0].rsymbol || "Overall"})`,
              type: "line",
              symbol: "none",
              color: echartslineColor[0],
              data: data.list[0].nativePrice.data,
            });
            list.push({
              name: data.list[0].rsymbol
                ? `Volume (${data.list[0].rsymbol})`
                : ``,
              type: "bar",
              symbol: "none",
              yAxisIndex: 1,
              color: echartslineColor[1],
              data: data.list[0].reddemAmount.data,
            });
          } else {
            setHindPrice(true);
            list.push({
              name: data.list[0].rsymbol
                ? `Volume (${data.list[0].rsymbol})`
                : ``,
              type: "bar",
              symbol: "none",
              yAxisIndex: 1,
              color: echartslineColor[1],
              data: data.list[0].reddemValue.data,
            });
          }

          setEchartList(list);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dropDownValue]);

  return (
    <div className="redeemValueContainer">
      <CardHead
        title="Redeem Value"
        tips={`Redeem Value in all the StaFi Appchains (Redeem Value = rToken Price x Redeem Amount), For the rBridge or Swap transactions, we take initiating chain rToken as the calculation unit.`}
      />
      <PricePanel
        text={
          <LoadingOutlined spin={loading}>{`$${formatNumber(allReddemValue, {
            decimals: 2,
          })} `}</LoadingOutlined>
        }
      />
      <Echarts
        dropDownDatas={dropDownDatas.filter((item) => {
          return !(dropDownValue == "Overall" && item.value == "Overall");
        })}
        onDropDownChange={(value: string) => {
          setDropDownValue(value);
        }}
        dropDownValue={dropDownValue}
        types={types}
        onTypeChange={(value: string) => {
          setTypeValue(value);
        }}
        typeValue={typevlue}
        hindPrice={hindPrice}
        updateTime={updateTime}
        datas={echartList}
        yData={yData}
        loading={loading}
      />
    </div>
  );
}
